import React from 'react';
import { Text, Flex } from '@fluentui/react-northstar';
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";

const LabelTextComponent = observer((props) => {
    const { label, text, testId } = props;

    return (
        <Flex column data-testid={testId + "Container"} className="label-text-component">
            <Text weight="semibold" content={label} data-testid={testId + "Label"} />
            <Text content={text} data-testid={testId + "Text"} />
        </Flex>
    );
});

LabelTextComponent.propTypes = {
    label: PropTypes.string,
    text: PropTypes.string,
    testId: PropTypes.string,
};

LabelTextComponent.defaultProps = {
    label: "",
    text: "",
}

export default LabelTextComponent;